import { useState } from 'react';
import ReactEasyCrop from 'react-easy-crop';
import antiClockwiseRotate from '../../assets/icons/antiClockwiserotate.svg';
import clockwiseRotate from '../../assets/icons/clockwiseRotate.svg';
import { ICoordinates } from '../modals/modalUpload/types';
import { useStyles } from './cropImage.styles';
import { IProps } from './types';

export const CropImage = ({ image, onCropComplete, rotation, setRotation }: IProps): JSX.Element => {
  const [crop, setCrop] = useState<ICoordinates>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const classes = useStyles();

  const rotateClockwise = (): void => {
    setRotation(rotation + 90);
  };

  const onRotationChange = (newRotation: number): void => {
    setRotation(newRotation);
  };

  const rotateCounterClockwise = (): void => {
    setRotation(rotation - 90);
  };

  return (
    <div>
      <ReactEasyCrop
        image={image}
        crop={crop}
        zoom={zoom}
        rotation={rotation}
        showGrid={false}
        aspect={3 / 3}
        objectFit="contain"
        cropShape="round"
        onCropChange={setCrop}
        onRotationChange={onRotationChange}
        onCropComplete={onCropComplete}
        onZoomChange={setZoom}
        style={{ containerStyle: { borderRadius: '5px' } }}
      />
      <div className={classes.buttonsContainer} >
        <img src={antiClockwiseRotate} className={classes.buttons} onClick={rotateCounterClockwise} />
        <img src={clockwiseRotate} className={classes.buttons} onClick={rotateClockwise} />
      </div>
    </div>
  );
};
